/* eslint-disable @next/next/no-img-element */
interface props {
  projectData: any;
  title: string;
  bgColor: string;
}

// TODO: Check if we can apply watermark on these images
export const PYPProjectAmentities = ({
  projectData,
  title,
  bgColor,
}: props) => {
  return (
    <div
      className={`mt-14 lg:mt-10 ${bgColor} clip-path-bottomRightPropertyCountCard lg:clip-path-bottomRightPostProperty py-6  lg:pt-8 lg:pb-9 px-6  xl:gap-12`}
    >
      <p className="font-openSans font-normal text-mobile-body-lg lg:text-[20px] leading-[22px] lg:leading-7 text-brand-bgBlack">
        {title}
      </p>
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-8 mt-7">
        {projectData?.map((item: any, index: any) => (
          <div className="flex items-center" key={index}>
            <img
              src={`${process.env.NEXT_PUBLIC_IMAGIX_URL}/${item?.uuid}`}
              className="w-5 h-5"
              alt=""
            />
            <p className="font-openSans font-normal ml-1  text-web-body-sm leading-4 text-brand-textGrey max-w-[100px] text-wrap">
              {item?.title}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PYPProjectAmentities;
